import { render, staticRenderFns } from "./MaskTopBarIcon.vue?vue&type=template&id=1b384dbe&"
import script from "./MaskTopBarIcon.vue?vue&type=script&lang=js&"
export * from "./MaskTopBarIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports